import api from "../../../shared/api.jsx";

/**
 * Feedback Service - API calls for feedback operations
 */

const BASE_URL = "/api/feedback";

/**
 * Create a new feedback request
 * @param {Object} requestData - Feedback request data
 * @returns {Promise<Object>} Creation result
 */
export const createFeedbackRequest = async (requestData) => {
  try {
    const response = await api.post(`${BASE_URL}/request`, {
      ...requestData,
      adminId: "admin", // TODO: Get from auth context
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Failed to create feedback request"
    );
  }
};

/**
 * Send feedback request message to customer
 * @param {string} requestId - Feedback request ID
 * @returns {Promise<Object>} Send result
 */
export const sendFeedbackRequest = async (requestId) => {
  try {
    const response = await api.post(`${BASE_URL}/request/${requestId}/send`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Failed to send feedback request"
    );
  }
};

/**
 * Cancel a feedback request
 * @param {string} requestId - Feedback request ID
 * @returns {Promise<Object>} Cancellation result
 */
export const cancelFeedbackRequest = async (requestId) => {
  try {
    const response = await api.delete(`${BASE_URL}/request/${requestId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Failed to cancel feedback request"
    );
  }
};

/**
 * Get feedback requests with filters
 * @param {Object} filters - Filter options
 * @returns {Promise<Object>} Filtered requests
 */
export const getFeedbackRequests = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.status) params.append("status", filters.status);
    if (filters.customerId) params.append("customerId", filters.customerId);
    if (filters.referenceType)
      params.append("referenceType", filters.referenceType);
    if (filters.adminId) params.append("adminId", filters.adminId);
    if (filters.limit) params.append("limit", filters.limit);
    if (filters.offset) params.append("offset", filters.offset);

    const response = await api.get(`${BASE_URL}/request?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Failed to fetch feedback requests"
    );
  }
};

/**
 * Get specific feedback request
 * @param {string} requestId - Feedback request ID
 * @returns {Promise<Object>} Feedback request data
 */
export const getFeedbackRequest = async (requestId) => {
  try {
    const response = await api.get(`${BASE_URL}/request/${requestId}`);
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.error || "Failed to fetch feedback request"
    );
  }
};

/**
 * Create general feedback
 * @param {Object} feedbackData - Feedback data
 * @returns {Promise<Object>} Creation result
 */
export const createGeneralFeedback = async (feedbackData) => {
  try {
    const response = await api.post(`${BASE_URL}/general`, feedbackData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || "Failed to create feedback");
  }
};
